// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "web-static-state/css/" + chunkId + "." + {"548":"0e3142cf","774":"97eb0b53","779":"5258adfb","999":"c6c3d4ef"}[chunkId] + ".css";
};